import $ from 'jquery';
import merge from 'lodash/merge';
import bind from 'lodash/bind';
import each from 'lodash/each';
import reduce from 'lodash/reduce';
import ModalComponent from 'components/modal';
import ButtonComponent from 'components/button';
import i18n from 'utils/i18n';
import IosAppUtil from 'utils/ios_app';

const UNNEEDED_ERROR_TYPE = 'store_id';

class SignUpModalComponent extends ModalComponent {
  constructor() {
    super();

    this.components = {
      submitButton: new ButtonComponent()
    };
  }

  static get defaults() {
    let defaults = merge({}, super.defaults, {
      trigger: '.sign-up-modal__trigger',
      selector: '.sign-up-modal',
      errorTimeout: 2500,
      successTimeout: 1250,
      submitTimeout: 1000,
      classes: {
        form: 'sign-up-modal__form',
        submitButton: 'sign-up-modal__submit-button',
        focusedField: 'sign-up-modal__focused-field',
        errors: 'sign-up-modal__errors',
        errorsVisible: 'sign-up-modal__errors--visible',
        success: 'sign-up-modal__success',
        successVisible: 'sign-up-modal__success--visible'
      }
    });

    return Object.freeze(defaults);
  }

  _reloadWindow() {
    window.location.reload();
  }

  _setPreloadState() {
    this.components.submitButton.setLoadingState();
  }

  _open(event) {
    super._open(event);

    this.options.$focusedField.focus();
  }

  _close() {
    super._close();

    this._clearSuccess();
    this._clearErrors();
    this.components.submitButton.removeStatefulClasses();
  }

  _setSuccess() {
    let {
      $success,
      classes
    } = this.options;
    let successMessage = i18n.t('components.sign_up_modal.success_message');

    $success.addClass(classes.successVisible);
    $success.html(successMessage);
  }

  _clearSuccess() {
    let {
      $success,
      classes
    } = this.options;

    $success.removeClass(classes.successVisible);
    $success.empty();
  }

  _buildErrors(errors) {
    return reduce(errors, ($errorsList, errorMessages, errorType) => {
      if (errorType === UNNEEDED_ERROR_TYPE) {
        return $errorsList;
      }

      each(errorMessages, (errorMessage) => {
        let $errorsListItem = $('<li />', { class: 'sign-up-modal__errors-list-item' });

        $errorsListItem.html(errorMessage);
        $errorsList.append($errorsListItem);
      });

      return $errorsList;
    }, $('<ul />', { class: 'sign-up__modal-errors-list' }));
  }

  _setErrors(errors) {
    let {
      $errors,
      classes
    } = this.options;
    let $errorsList = this._buildErrors(errors);

    $errors.addClass(classes.errorsVisible);
    $errors.html($errorsList);
  }

  _clearErrors() {
    let {
      $errors,
      classes
    } = this.options;

    $errors.removeClass(classes.errorsVisible);
    $errors.empty();
  }

  _onSuccess() {
    this.components.submitButton.setSuccessState();

    this._clearErrors();
    this._setSuccess();

    IosAppUtil.userSignedIn(arguments[0]['email']);

    setTimeout(
      bind(this._reloadWindow, this),
      this.options.successTimeout
    );
  }

  _onError(xhr) {
    let { submitButton } = this.components;
    let errors           = JSON.parse(xhr.responseText).errors;

    this._setErrors(errors);
    submitButton.setErrorState();

    setTimeout(() => {
      submitButton.removeStatefulClasses();
    }, this.options.errorTimeout);
  }

  _onFormSubmit(event) {
    event.preventDefault();

    let $form  = $(event.currentTarget);
    let url    = $form.attr('action');
    let data   = $form.serialize();

    this._setPreloadState();

    setTimeout(() => {
      $.ajax({
        url,
        data,
        method: 'POST',
        dataType: 'json'
      }).then(
        bind(this._onSuccess, this),
        bind(this._onError, this)
      );
    }, this.options.submitTimeout);
  }

  _setDomDependentOptions() {
    super._setDomDependentOptions();

    let {
      $scope,
      classes
    } = this.options;

    this.options.$form         = $scope.find(`.${classes.form}`);
    this.options.$submitButton = $scope.find(`.${classes.submitButton}`);
    this.options.$focusedField = $scope.find(`.${classes.focusedField}`);
    this.options.$errors       = $scope.find(`.${classes.errors}`);
    this.options.$success      = $scope.find(`.${classes.success}`);
  }

  _attach() {
    super._attach();

    this.options.$form.on('submit.sign-up-modal:form-submit', bind(this._onFormSubmit, this));
  }

  init(options = {}) {
    super.init(options);

    this.components.submitButton.init({
      selector: `.${this.options.classes.submitButton}`
    });
  }
}

export default SignUpModalComponent;
